import { Button, Container, FormField, Input, Modal } from '@cloudscape-design/components';
import Calendar from "@cloudscape-design/components/calendar";
import { mdiCalendarArrowLeft, mdiCalendarArrowRight, mdiCalendarToday, mdiDeleteOutline, mdiWindowClose } from '@mdi/js';
import Icon from '@mdi/react';
import { addDays, format, parse } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { hideKeyboardGlobally } from '../pages/commons/functions';
import { btnIcon } from '../resources/types';
interface ItemPeriod {
  period: string;
  month: number;
  year: number;
}
interface MPModalProps {
  close?: boolean;
  clear?: boolean;
  today?: boolean;
  nextMonth?: boolean;
  prevMonth?: boolean;
  start?: Date;
  end?: Date;
  date?: string
  title?: string;
  subTitle?: string;
  disabledDates?: string[];
  width?: number;
  //onDismiss: () => void;
  onConfirm?: (selectedDate: ItemPeriod) => void;
}
const MPModal: React.FC<MPModalProps> = ({
  close = false,
  clear = true,
  today = false,
  nextMonth = false,
  prevMonth = false,
  start = undefined,
  end = undefined,
  date = "",
  title = 'Seleccione',
  subTitle = '',
  disabledDates = [],
  width = 200,
  onConfirm,
}) => {
  const getDateObject = (d: string): ItemPeriod | null => {
    if (!d || d === "") return null;
    const parts = d.replace("/", "-").split("-");
    return {
      period: Number(parts[0]).toString().padStart(2, "0") + "-" + Number(parts[1]).toString().padStart(2, "0"),
      year: Number(parts[0]),
      month: Number(parts[1])
    };
  };
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [showModal, setShowModal] = useState<boolean>(false);
  const handleDateChange = ({ detail }: { detail: { value: string } }) => {
    setSelectedDate(detail.value);
    onConfirm?.(getDateObject(detail.value));
    date = detail.value
    hideKeyboardGlobally();
    onDismiss();
  };
  const onDismiss = () => {
    setShowModal(false);
  }
  const dateClear = () => {
    setSelectedDate('')
    onConfirm?.(null);
  }
  useEffect(() => {
    if (!date || date === "") {
      setSelectedDate(null)
    } else {
      setSelectedDate(getDateObject(date).period)
    }

  }, [date])
  const mapDateStringsToDates = (dateStrings: string[]): Date[] => {
    return dateStrings.map(item =>
      // The parse function requires the date string, the format, and a reference date
      parse(item, "dd-MM-yyyy", new Date())
    );
  };

  // This is the array (list of Date objects) you will check against:
  const disabledDatesArray: Date[] = mapDateStringsToDates(disabledDates);

  const isSameDay = (date1: Date, date2: Date): boolean => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };
  const isDateInDisabledList = (d: Date): boolean => {
    // Use .some() to check if ANY disabledDate in the array matches the input date (d)
    return disabledDatesArray.some(disabledDate => isSameDay(d, disabledDate));
  };
  const dateToday = () => {
    const formatted = format(new Date(), "yyyy-MM");
    setSelectedDate(formatted)
    onConfirm?.(getDateObject(formatted));
    onDismiss();
  }
  const dateYesterday = () => {
    const formatted = format(addDays(new Date(), -1), "yyyy-MM");
    setSelectedDate(formatted)
    onConfirm?.(getDateObject(formatted));
    onDismiss();
  }
  const dateTomorrow = () => {
    const formatted = format(addDays(new Date(), 1), "yyyy-MM");
    setSelectedDate(formatted)
    onConfirm?.(getDateObject(formatted));
    onDismiss();
  }
  const normalizedStart = start ? new Date(start.getFullYear(), start.getMonth(), start.getDate()) : undefined;
  const normalizedEnd = end ? new Date(end.getFullYear(), end.getMonth(), end.getDate()) : undefined;
  //const normalizedDate = end ? new Date(date.getFullYear(), date.getMonth(), date.getDate()) : undefined;
  const isDateInRange = (date: Date) => {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    if (normalizedStart && normalizedEnd) return d >= normalizedStart && d <= normalizedEnd;
    if (normalizedStart) return d >= normalizedStart;
    if (normalizedEnd) return d <= normalizedEnd;
    return true;
  };


  return (
    <>
      <div onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true)
      }} style={{ cursor: 'pointer', maxWidth: width }}>
        <Input value={selectedDate} onChange={() => { }} placeholder='Seleccionar fecha'
          inputMode="none" readOnly
          style={{
            root: {
              borderColor: {
                readonly: "#8c8c94",
                focus: "#8c8c94"
              }
            }
          }}
        />
      </div>
      <Modal
        visible={showModal}
        onDismiss={onDismiss}
        size="small"
        header={title}
        footer={
          <div className='containerFooterButtons'>
            {close && (
              <div><Button style={{ root: btnIcon }} onClick={onDismiss}><Icon path={mdiWindowClose} size={1} /></Button></div>
            )}
            {prevMonth && (
              <div><Button style={{ root: btnIcon }} onClick={dateYesterday}><Icon path={mdiCalendarArrowLeft} size={1} /></Button></div>
            )}
            {today && (
              <div><Button style={{ root: btnIcon }} onClick={dateToday}><Icon path={mdiCalendarToday} size={1} /></Button></div>
            )}
            {nextMonth && (
              <div><Button style={{ root: btnIcon }} onClick={dateTomorrow}><Icon path={mdiCalendarArrowRight} size={1} /></Button></div>
            )}
            {clear && (
              <div><Button style={{ root: btnIcon }} onClick={dateClear}><Icon path={mdiDeleteOutline} size={1} /></Button></div>
            )}
          </div>
        }
      >
        <FormField label={subTitle} stretch>
          <Container>

            <Calendar
              value={date}

              onChange={handleDateChange}
              locale="es-CL"
              startOfWeek={1}
              isDateEnabled={(date) => {
                return isDateInRange(date) && !isDateInDisabledList(date)

              }}
              granularity="month"
            />
          </Container>
        </FormField>
      </Modal >
    </>
  );
};

export default MPModal;